export default __webpack_public_path__ + "static/media/Caja_larga_eneable.e7e44b4f.svg";